export default function getDemographicsModel () {
  const stringed = JSON.stringify({
    age: {
      lowerBound: undefined,
      upperBound: undefined
    },
    socioEconomic: {
      lowerBound: undefined,
      upperBound: undefined
    },
    gender: {
      targetMale: true,
      targetFemale: true
    },
    location: {
      address: undefined,
      street: undefined,
      town: undefined,
      state: undefined,
      country: undefined,
      zipcode: []
    },
    keyWords: undefined
  })
  return JSON.parse(stringed)
}